import * as type from '../mutation-types'

const state = {
  info:"",
  ossSignature:""
};

const getters={

};
const mutations={
  [type.UPDATA_ACCOUNT](state,info){
    state.info=info;
    localStorage.setItem('account',JSON.stringify(info));
  },
  [type.UPDATA_OSS_SIGNATURE](state,ossSignature){
    state.ossSignature=ossSignature;
    localStorage.setItem('ossSignature',JSON.stringify(ossSignature));
  },

};
const actions={
  updataAccount({commit,state},account){
    commit(type.UPDATA_ACCOUNT,account);
  },
  updataOssSignature({commit,state},ossSignature){
    commit(type.UPDATA_OSS_SIGNATURE,ossSignature);
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/account.js